import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/observable/throw'
import 'rxjs/add/operator/catch';
import {PlatformLocation } from '@angular/common';

import { GlobalService} from './services/global.service'


@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
    token: string;
    header: HttpHeaders;
    url: string;
    constructor(private globals: GlobalService, private platformLocation: PlatformLocation) {
        this.token = localStorage.getItem("token");
        this.header = new HttpHeaders();
        this.header = this.header.append('Content-Type', 'application/json');
        this.header = this.header.append('withCredentials', 'true');
        if(this.token != null){
            this.header = this.header.append('Authorization', this.token);
        }
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authReq;
        this.token = localStorage.getItem("token");
        this.header = new HttpHeaders();
        this.header = this.header.append('Content-Type', 'application/json');
        this.header = this.header.append('withCredentials', 'true');
        if(this.token != null){
            this.header = this.header.append('Authorization', this.token);
        }
        authReq = req.clone({ headers : this.header});
        return next.handle(authReq)
        .map((event: HttpEvent<any>) => {
            if(event instanceof HttpResponse){
                if((<HttpResponse<any>>event).headers.get('Authorization')){
                    this.token = (<HttpResponse<any>>event).headers.get('Authorization');
                    localStorage.setItem("token", this.token);
                    sessionStorage.setItem("token", this.token);
                    this.header = new HttpHeaders();
                    this.header = this.header.append('Authorization', this.token);
                    this.header = this.header.append('Content-Type', 'application/json');
                    this.header = this.header.append('withCredentials', 'true');        
                }
            }
            return event;
        })
        .catch((error, caught) => {
            if(error.status == 401){
                if(this.url.indexOf("?id=") < 0){
                    localStorage.removeItem("token");
                    sessionStorage.removeItem("token");
                }
                this.token = null;
                this.header = new HttpHeaders();
                this.header = this.header.append('Content-Type', 'application/json');
                this.header = this.header.append('withCredentials', 'true');
            } else if(error.status == 200){
                const res = new HttpResponse({
                    body: error.error.text,
                    headers: error.headers,
                    status: error.status,
                    statusText: error.statusText,
                    url: error.url
                });
                return Observable.of(res);
            } else{
                //console.log(1);
                //show alert saying server error
            }
            return Observable.throw(error);
        }) as any;
    }
}


// WEBPACK FOOTER //
// ./src/app/http-interceptor.ts